<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <v-btn
            :icon="!$vuetify.breakpoint.smAndUp"
            :color="$store.state.global.pages.rate.color"
            flat
            router
            :to="{name: 'rate'}"
          >
            <v-icon :left="$vuetify.breakpoint.smAndUp">{{$store.state.global.pages.rate.icon}}</v-icon>
            {{$vuetify.breakpoint.smAndUp ? 'Show Rates' : ''}}
          </v-btn>
          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
        <!-- <v-btn flat color="grey" @click="toggleView()">         
                    <v-icon left v-if="listView">list</v-icon>
                    <v-icon left v-else>view_module</v-icon>
                    View
        </v-btn>-->
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
      </layout-no-padding>

      <v-dialog
        v-model="addClientDialog"
        max-width="500px"
        @keydown.esc="addClientDialog = false"
        v-if="userAuthClass"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-client" slot="activator">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-client @close="addClientDialog = false" v-if="userAuthClass"></add-client>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ClientValidation from "@/services/validation/clientValidation";
import AddClient from "@/components/clients/addClient";
import RouteProps from "@/services/mixins/routeProps";

//GET RECORDS
import getClients from "@/services/mixins/getMasterFiles/getClients";
export default {
  mixins: [ClientValidation, RouteProps, getClients],
  data() {
    return {
      addClientDialog: false,
      sortFactors: [
        {
          value: "id",
          text: "ID"
        },
        {
          value: "name",
          text: "Name"
        },
        {
          value: "updatedAt",
          text: "Updated At"
        }
      ]
    };
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    },
    sortClients(path1, path2) {
      return this.clients.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1;
        } else {
          return 1;
        }
      });
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "clients", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "clients", prop: "filterBy" }),
    listView: Store.getSet({ store: "clients", prop: "listView" })
  },
  components: {
    AddClient
  }
};
</script>

<style scoped>
.overlap-fab-client {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>

